export const roleByLabel = {
  'Administrador':'admin',
  'NSP':'nsp',
  'Qualidade da unidade':'location_qa',
  'Gestor da unidade':'location_manager',
  'Diretoria Qualidade Corporativa':'corporate_quality_board',
  'Gestão Qualidade Corporativa':'corporate_quality_management',
  'Diretor Geral Unidade':'unit_general_manager'
}